
import Hero from "../../../components/Hero";
import ProductInfo from "../../../components/ProductInfo";
import Page from "../../../components/Page.vue";
import {
    createBreadcrumbSchema,
    createSchemaHead,
    getAbsoluteImageUrl,
    getCanonicalUrl,
    getCurrentUrl,
    getSiteCurrency,
    stripHtml,
} from "../../../utils/schema";
export default {
    name: 'ProductPage',
    components: {Page, ProductInfo, Hero},
    async asyncData({ $axios, route, error }) {
        try {
            const res = await $axios.get('api/v1/product', {
                params: {
                    slug: route.params.slug,
                }
            });

            return {
                product: res.data.product,
                colorVariations: res.data.additional_data && Array.isArray(res.data.additional_data.color_variations)
                    ? res.data.additional_data.color_variations
                    : [],
                h1: res.data.product.seo_h1,
                title: res.data.product.seo_title,
                description: res.data.product.seo_description,
            }
        }
        catch (e) {
            error({ statusCode: 404, message: 'Product not found' });
        }

    },
    head() {
        const canonical = getCanonicalUrl(this);
        const currentUrl = getCurrentUrl(this);
        const description = this.description || stripHtml(this.product && this.product.text);
        const offerPrice = this.product.price_special || this.product.price || null;
        const image = getAbsoluteImageUrl(this, this.product && this.product.image
            ? ((this.product.image.sizes && (this.product.image.sizes.big || this.product.image.sizes.medium)) || this.product.image.path)
            : null);
        const breadcrumb = createBreadcrumbSchema(this, [
            { name: 'Главная', path: '/' },
            { name: this.product && this.product.category ? this.product.category.name : 'Категория' },
            { name: this.h1 || this.product.name, path: this.$route.path || '/' },
        ], '#breadcrumbs');
        const productSchema = {
            '@type': 'Product',
            '@id': `${canonical}#product`,
            url: currentUrl,
            name: this.h1 || this.product.name,
            description: description || undefined,
            sku: this.product.sku || undefined,
            image: image || undefined,
            category: this.product && this.product.category ? this.product.category.name : undefined,
        };

        if (offerPrice && this.product.available) {
            productSchema.offers = {
                '@type': 'Offer',
                url: currentUrl,
                price: offerPrice,
                priceCurrency: getSiteCurrency(this),
                availability: 'https://schema.org/InStock',
                itemCondition: 'https://schema.org/NewCondition',
            };
        } else if (offerPrice) {
            productSchema.offers = {
                '@type': 'Offer',
                url: currentUrl,
                price: offerPrice,
                priceCurrency: getSiteCurrency(this),
                availability: 'https://schema.org/OutOfStock',
                itemCondition: 'https://schema.org/NewCondition',
            };
        }

        const schemaHead = createSchemaHead([
            {
                '@type': 'WebPage',
                '@id': `${canonical}#webpage`,
                url: canonical,
                name: this.title ? this.title : this.product.name,
                description: description || undefined,
                breadcrumb: breadcrumb ? {
                    '@id': breadcrumb['@id'],
                } : undefined,
                mainEntity: {
                    '@id': productSchema['@id'],
                },
            },
            breadcrumb,
            productSchema,
        ], 'schema-org-product');

        return {
            title: this.title ? this.title : this.product.name,
            meta: [
                { hid: 'description', name: 'description', content: description },
                { hid: 'keywords', name: 'keywords', content: '' },
            ],
            link: [
                { hid: 'canonical', rel: 'canonical', href: canonical },
            ],
            ...schemaHead,
        }
    },
    data() {
        return {
            seo: false,
            process: false,
        }
    },
    methods: {
        async submit(){
            this.process = true;
            try {
                let response = await this.$axios.post('/api/v1/seo/product', {
                    id: this.product.id,
                    seo_h1: this.h1,
                    seo_title: this.title,
                    seo_description: this.description,
                });
                this.process = false;
                this.seo = false;
            } catch (e) {
                if (e.response.status === 422) {
                    this.error = 'Некорректно отправлена форма';
                } else {
                    this.error = 'Системная ошибка, попробуйте позже';
                }
                alert(this.error);
                this.process = false;
            }
        },
    },
}
